// extracted by mini-css-extract-plugin
module.exports = {"iconSync":"TempHotelResults_iconSync__1aocY","fa-spin":"TempHotelResults_fa-spin__2ipiE"};